// ------------------------------------
// Constants
// ------------------------------------
export const TOGGLE_FEEDS_FILTER = 'TOGGLE_FEEDS_FILTER'
export const TOGGLE_FEEDS_HEIGHT = 'TOGGLE_FEEDS_HEIGHT'
export const SET_SCROLL_HEIGHT = 'SET_SCROLL_HEIGHT'
export const SET_KNOBS_PANEL_TOP_MARGIN = 'SET_KNOBS_PANEL_TOP_MARGIN'

// ------------------------------------
// Actions
// ------------------------------------
export function toggleFeedsFilter(payload) {
  return { type: TOGGLE_FEEDS_FILTER, payload }
}

export function toggleFeedsHeight(payload) {
  return { type: TOGGLE_FEEDS_HEIGHT, payload }
}

export function setScrollHeight(payload) {
  return { type: SET_SCROLL_HEIGHT, payload }
}

export function setKnobsPanelTopMargin(payload) {
  return { type: SET_KNOBS_PANEL_TOP_MARGIN, payload }
}

// ------------------------------------
// Selects
// ------------------------------------

export const selectIsFeedsListExpanded = getState => getState.ui.isFeedsListExpanded

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFeedsListExpanded: false,
  feedsHeight: 62,
  scrollHeight: 0,
  knobsPanelTopMargin: 0
}

export default function(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_FEEDS_FILTER:
      return {
        ...state,
        isFeedsListExpanded: action.payload
      }
    case TOGGLE_FEEDS_HEIGHT:
      return {
        ...state,
        feedsHeight: action.payload
      }
    case SET_SCROLL_HEIGHT:
      return {
        ...state,
        scrollHeight: action.payload,
        knobsPanelTopMargin: action.payload
      }
    case SET_KNOBS_PANEL_TOP_MARGIN:
      return {
        ...state,
        knobsPanelTopMargin: action.payload
      }
    default:
      return state
  }
}
